import SelectClientStep from 'src/UI/drawer-flow/SelectClientStep';
import { StepProps } from 'src/UI/drawer-flow/DrawerFlow';
import { Client } from 'src/users';

type DataWithClient = {
  client?: Client;
};

export default function MeetingNoteSelectClientStep<T extends DataWithClient>(props: StepProps<T>) {
  return (
    <SelectClientStep
      {...props}
      description="Select the client you wish to generate a meeting note for"
    />
  );
}
